import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { DataTablesModule } from 'angular-datatables';
import { NpnSliderModule } from "npn-slider";
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { MapComponent } from './map/map.component';
import { TripComponent } from './trip/trip.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { ReportComponent } from './report/report.component';
import { SidebarComponent } from './partials/sidebar/sidebar.component';
import { LeftMenuComponent } from './partials/left-menu/left-menu.component';
import { RightCounterComponent } from './partials/right-counter/right-counter.component';
import { MasterAccountComponent } from './dialogs/master-account/master-account.component';
import { FullHeightDirective } from './directive/full-height.directive';
import { FleetListComponent } from './partials/fleet-list/fleet-list.component';
import { GoogleMapComponent } from './partials/google-map/google-map.component';
import { GmapComponent } from './partials/gmap/gmap.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ScrollableModalDirective } from './directive/scrollable-modal.directive';
import { SharedMapComponent } from './shared-map/shared-map.component';
import { OpenmapComponent } from './partials/openmap/openmap.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MapComponent,
    TripComponent,
    VehiclesComponent,
    ReportComponent,
    SidebarComponent,
    LeftMenuComponent,
    RightCounterComponent,
    MasterAccountComponent,
    FullHeightDirective,
    FleetListComponent,
    GoogleMapComponent,
    GmapComponent,
    ScrollableModalDirective,
    SharedMapComponent,
    OpenmapComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
	FormsModule,
	HttpClientModule,
	GoogleMapsModule,
	DataTablesModule,
	NpnSliderModule,
	NgxSliderModule,
 ServiceWorkerModule.register('ngsw-worker.js', {
   enabled: environment.production,
   // Register the ServiceWorker as soon as the application is stable
   // or after 30 seconds (whichever comes first).
   registrationStrategy: 'registerWhenStable:30000'
 })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
